module.exports = __webpack_public_path__ + "assets/img/sjly_icon.dd0457d4.png";